import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Page } from "src/app/model/Page";
import { ModalController } from "@ionic/angular";
import { PossessionDtlUpdateService } from "src/app/services/possession-dtl-update.service";
import { UpdatePossessionDtlListModel } from "src/app/model/UpdatePossessionDtlListModel";

@Component({
  selector: "app-secure-update-possession-dtl-list",
  templateUrl: "./update-possession-dtl-list.component.html",
  styleUrls: ["./update-possession-dtl-list.component.scss"],
})

export class UpdatePossessionDtlListComponent implements OnInit, AfterViewInit {
  list : Page<UpdatePossessionDtlListModel>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<UpdatePossessionDtlListModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "applicationNo",
    "applicantName",
    "lsct",
    "status",
    "action",    
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  
  filteredListParams: {
    filterText: string,
  };

  constructor(
    private possessionDtlUpdateService: PossessionDtlUpdateService,
    private _snackBar: MatSnackBar, private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.minLength(3), Validators.required]),
    }); 
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.onDataLoad();
    }
    else {
      this._snackBar.open("Please Select Mandatory fields", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  resetFilter() {
    this.ngOnInit();
  }

  removeSearchedListAndSavedFilter() {
    this.filteredListParams = null;
    this.list = null;
    this.dataSource = null;
    this.paginator.pageIndex = 0;
    this.paginator.length = 0; 
  }

  onDataLoad() {
    this.isLoading = true;
    this.isSearchDisabled = true;
    this.filteredListParams = {
      filterText: this.filterForm.value?.filterText,
    };
    
    this.possessionDtlUpdateService.fetchApplicationListForPossessionDtlUpdate(
      this.currentPage,
      this.pageSize,
       this.filterForm.value?.filterText
    ).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          console.log(data);
          this.list = data.data;
          this.dataSource = new MatTableDataSource(data.data.content);
          
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = data.data.totalElements;
          });
    
          this.isSearchDisabled = false;
        }
        else {
          this.possessionDtlUpdateService.errorToast(data.errorMessage);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
        this.possessionDtlUpdateService.errorToast(error?.error?.errorMessage||error?.errorMessage);
      }
    );
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onDataLoad();
  }
  async revert(applicationNo: string) {
console.log("Hit",applicationNo);
if(applicationNo !==null ){
  console.log(applicationNo,"revertCalled");
   this.possessionDtlUpdateService.revertPossession(applicationNo)
  .subscribe((data) => {
     this.isLoading = false;
     this.isLoading = false;
     this.possessionDtlUpdateService.successToast("Possission Letter Reverted To regenrate");
      this.onDataLoad();
   }, error => {
     this.isLoading = false;
    this.possessionDtlUpdateService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);


   });

} else {
  this.possessionDtlUpdateService.errorToast("Please Enter Application Number");  
}
  }

  async revertAllotment(applicationNo: string) {
    if(applicationNo !==null ){
      console.log(applicationNo,"revertAllotmentCalled");
       this.possessionDtlUpdateService.revertAllotment(applicationNo)
       .subscribe((data) => {
          this.isLoading = false;
          this.isLoading = false;
          this.possessionDtlUpdateService.successToast("Allotment Letter Reverted To regenrate");
           this.onDataLoad();
        }, error => {
          this.isLoading = false;
         this.possessionDtlUpdateService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    
    
        });
    
    } else {
      this.possessionDtlUpdateService.errorToast("Please Enter Application Number");  
    }
      }

 

    
 
   
 

}